var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRefused(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 19.306,
    height: 19.304,
    viewBox: "0 0 19.306 19.304",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Uni\\xE3o_1",
    "data-name": "Uni\\xE3o 1",
    d: "M7354.184,3649.6l-8.239-8.238-8.239,8.238-1.414-1.414,8.239-8.238-8.239-8.238,1.414-1.414,8.239,8.238,8.239-8.238,1.414,1.415-8.239,8.238,8.239,8.238Z",
    transform: "translate(-7336.292 -3630.293)",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRefused);
export default __webpack_public_path__ + "static/media/refused.a9cee4170af3fbf72bc824d4158e654f.svg";
export { ForwardRef as ReactComponent };